import React, { useEffect } from 'react';
import image from '../../assets/Images/LoginImage.png';
import SoilDoctorLogo from '../../assets/Images/SoilDoctorLogo.png';
import { Link, useNavigate } from 'react-router-dom';
import { Formik, Field } from 'formik';
import { Col, Form, Row } from 'react-bootstrap';

import * as Yup from 'yup';

import { login } from '../../store/features/partnerSlice';
import { useDispatch, useSelector } from 'react-redux';

// for form validation
const schema = Yup.object({
  email: Yup.string()
    .trim()
    .required('Email is required')
    .email('Invalid Email ID'),
  password: Yup.string().required('Password is required'),
});

function generateClassName(errors, touched, fieldName) {
  const hasError = errors[fieldName] && touched[fieldName];
  const isSuccess = touched[fieldName];
  return `form-control ${
    hasError
      ? 'border-2 border-danger'
      : isSuccess
      ? 'border-2 border-success'
      : ''
  }`;
}

const PartnerLogin = () => {

  const { status } = useSelector((state) => state.partner);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
  if (status === 'succeeded') {
    navigate("/");
  }
}, [status, navigate]);

  return (
    <div className='login-container m-0'>
      {/* Left content */}
      <div className='login-left'>
        <div className='logo'>
          <img src={SoilDoctorLogo} alt='Logo' width='250px' />
        </div>
        <div className='left-content'>
          <h1 className='fw-bolder pt-5'>Welcome to Soil Doctor!</h1>
          <img src={image} alt='Background' className='responsive-image' />
          <figure className='w-75'>
            <blockquote className='blockquote'>
              <h3>
                To forget how to dig the earth and to tend the soil is to forget
                ourselves.
              </h3>
            </blockquote>
            <figcaption className='blockquote-footer'>
              <cite title='Source Title'>Mohandas K. Gandhi</cite>
            </figcaption>
          </figure>
        </div>
      </div>
      {/* Right content */}
      <div className='login-right'>
        <div className='login-form' contentEditable={false}>
          <h1 className=''>Sign in to Soil Doctor</h1>
          <div className='mb-5'>
            New user?
            <Link to='/partner/register' className=''>
              {' '}
              Enable yourself as a partner
            </Link>
          </div>

          {/* Form */}
          <Formik
            initialValues={{ email: '', password: '' }}
            validationSchema={schema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              console.log('VALUES: ', values);
              // axios
              //   .post(
              //     `${API_URL}admin/login`,
              //     { withCredentials: true },
              //     {
              //       headers: {
              //         Authorization: `Basic ${btoa(
              //           `${values.email}:${values.password}`
              //         )}`,
              //       },
              //     }
              //   )
              //   .then(({ data }) => {
              //     setSubmitting(false);
              //     auth.collectUserData();
              //     window.location.reload();
              //   })
              //   .catch((err) => {
              //     alert(err.response.data.msg);
              //     console.log('ERROR: ', err);
              //     setSubmitting(false);
              //   });
              // dispatch(login({values.email, values.password}))
              dispatch(
                login({ email: values.email, password: values.password })
              );
            }}
          >
            {({
              values,
              handleChange,
              handleSubmit,
              setFieldValue,
              setFieldTouched,
              errors,
              touched,
            }) => (
              <Form onSubmit={handleSubmit} onChange={handleChange}>
                <Row className='mb-3'>
                  {/* email */}
                  <Col md={12}>
                    <div>
                      <div className='form-floating'>
                        <Field
                          type='email'
                          name='email'
                          id='email'
                          value={values.email}
                          placeholder='Entered Registered Email'
                          className={generateClassName(
                            errors,
                            touched,
                            'email'
                          )}
                          onChange={handleChange}
                        />
                        <Form.Label htmlFor='companyName'>
                          Enter Registered Email
                          <span className='text-danger'>&nbsp;*</span>
                        </Form.Label>
                      </div>
                      {errors.email && touched.email ? (
                        <div className='form_errors'>
                          {' '}
                          &#9888; {errors.email}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                </Row>

                <Row className='mb-3'>
                  {/* password */}
                  <Col md={12}>
                    <div>
                      <div className='form-floating'>
                        <Field
                          type='password'
                          name='password'
                          id='password'
                          value={values.password}
                          placeholder='Enter Password'
                          className={generateClassName(
                            errors,
                            touched,
                            'password'
                          )}
                          onChange={handleChange}
                        />
                        <Form.Label htmlFor='password'>
                          Enter Password
                          <span className='text-danger'>&nbsp;*</span>
                        </Form.Label>
                      </div>
                      {errors.password && touched.password ? (
                        <div className='form_errors'>
                          {' '}
                          &#9888; {errors.password}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                
                <button
                  type='submit'
                  className='w-100 text-center btn btn-dark'
                >
                  <span>Login</span>
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default PartnerLogin;
